import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { async } from '@angular/core/testing';
import { AppConfig } from '../config/app-config';

@Component({
  selector: 'app-subscription-popup',
  templateUrl: './subscription-popup.component.html',
  styleUrls: ['./subscription-popup.component.css']
})
export class SubscriptionPopupComponent implements OnInit {

  showPopup = true;


  /*DisplayDelay() {
    this.showPopup = true;
  }; */

  closePopup() {
    this.showPopup = false;
  }

  name: string;
  company: string;
  email: string;
  contact: string;

  constructor(private http: HttpClient, private appConfig: AppConfig) {

    /* set timer to show the subscribe popup
    setTimeout(() => {
      console.log('Delay is over');
      this.showPopup = true;
    }, 5000); 
    async function delay(ms: number) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
    async function DisplayDelay() {
      console.log('Before Delay');
      await delay(5000);
      const showPopup = true;
      console.log('After Delay');
    }
    DisplayDelay(); */

  }

  ngOnInit() {
  }

  subscribe() {
    const subscriptionData = {
      Name: this.name,
      CompanyName: this.company,
      EmailAddress: this.email,
      ContactNumber: this.contact
    };

    let url = this.appConfig.apiUrl + '/SubscribeNewsletter';

    var reqHeaders = this.buildHeaders();

    console.log(subscriptionData);
    this.http.post<any>(url, subscriptionData, { headers: reqHeaders })
      .subscribe(
        response => console.log(response),
        error => console.log(error)
      );

      this.closePopup();
  }

  buildHeaders() {
    return new HttpHeaders({
      "Access-Control-Allow-Origin": "*",
      "content-type": "application/json; charset=utf-8"
    });
  }

}
